import React from 'react';

export const ReleasePageOptionIcon = ({
  branding,
  customizable,
}: {
  branding?: boolean;
  customizable?: boolean;
}) => {
  return (
    <svg
      width="265"
      height="164"
      viewBox="0 0 265 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page Mock">
        <g clipPath="url(#clip0_185_919)">
          <g id="Right">
            <rect
              width="100"
              height="164"
              transform="translate(164.5)"
              fill="var(--surface-container-high)"
            />
            <g id="Release Cover">
              <g clipPath="url(#clip1_185_919)">
                <rect
                  x="180.5"
                  y="16"
                  width="36"
                  height="36"
                  rx="4"
                  fill="#CCA057"
                />
                <path
                  id="Human Head"
                  d="M209 30.5C208.143 26.9622 205.5 24 200.5 24C196 24 194.985 25 193.485 26C192.74 26.4961 191.5 28.3333 191.5 29V31C191.5 31.4 189.5 32.5 188.5 33C188 34 189.5 34 189.5 34.5C189 35 189 35 188.5 35C188.1 35.4 188.5 36.1667 189 36.5C188.834 36.5 188 36.6 188 37C188.5 37.5 188.5 37.5 188.5 37.9999V38C188.5 38.5 187.648 40.0737 188.5 40.5C189.5 41 193 41.5 194.5 42C196 42.5 196.5 45.5 196 48C195.6 50 193.167 52.1667 192 53H208.5C208.5 51 205.5 46.5 205 45.5C204.5 44.5 204 42.5 204 41C204 40 206.969 38 207.985 35.5L207.994 35.5091C208.491 36.0062 209 36.5152 209 39C209 41.5 208 45.5 208.5 48C209.05 50.7456 209.5 52 209.5 53H213C212.5 51.5 212 52 211.25 48C210.513 44.0685 211.848 40.4827 211.5 37C211.25 34.5 209.485 32.5 209 30.5Z"
                  fill="url(#paint0_linear_185_919)"
                />
              </g>
            </g>
            <g id="Cards">
              <rect
                id="Card 1"
                x="180.5"
                y="68"
                width="68"
                height="14"
                rx="4"
                fill="var(--on-surface)"
                fillOpacity="0.05"
              />
              <rect
                id="Card 2"
                x="180.5"
                y="90"
                width="68"
                height="14"
                rx="4"
                fill="var(--on-surface)"
                fillOpacity="0.05"
              />
              <rect
                id="Card 3"
                x="180.5"
                y="112"
                width="68"
                height="14"
                rx="4"
                fill="var(--on-surface)"
                fillOpacity="0.05"
              />
              <rect
                id="Card 4"
                x="180.5"
                y="134"
                width="68"
                height="14"
                rx="4"
                fill="var(--on-surface)"
                fillOpacity="0.05"
              />
            </g>
          </g>
          <g id="Left">
            <rect
              width="164"
              height="164"
              transform="translate(0.5)"
              fill="var(--on-surface)"
              fillOpacity="0.1"
            />
            {customizable && (
              <>
                <g id="Social Networks">
                  <rect
                    id="Social Network 1"
                    x="16.5"
                    y="134"
                    width="12"
                    height="12"
                    rx="4"
                    fill="var(--surface-container-high)"
                  />
                  <rect
                    id="Social Network 2"
                    x="36.5"
                    y="134"
                    width="12"
                    height="12"
                    rx="4"
                    fill="var(--surface-container-high)"
                  />
                  <rect
                    id="Social Network 3"
                    x="56.5"
                    y="134"
                    width="12"
                    height="12"
                    rx="4"
                    fill="var(--surface-container-high)"
                  />
                  <rect
                    id="Social Network 4"
                    x="76.5"
                    y="134"
                    width="12"
                    height="12"
                    rx="4"
                    fill="var(--surface-container-high)"
                  />
                  <rect
                    id="Social Network 5"
                    x="96.5"
                    y="134"
                    width="12"
                    height="12"
                    rx="4"
                    fill="var(--surface-container-high)"
                  />
                </g>
                <g id="Tabs">
                  <rect
                    id="Tab 1"
                    x="64.5"
                    y="30"
                    width="21"
                    height="8"
                    rx="4"
                    fill="var(--surface-container-high)"
                  />
                  <rect
                    id="Tab 2"
                    opacity="0.5"
                    x="89.5"
                    y="30"
                    width="17"
                    height="8"
                    rx="4"
                    fill="var(--surface-container-high)"
                  />
                  <rect
                    id="Tab 3"
                    opacity="0.5"
                    x="110.5"
                    y="30"
                    width="17"
                    height="8"
                    rx="4"
                    fill="var(--surface-container-high)"
                  />
                  <rect
                    id="Tab 4"
                    opacity="0.5"
                    x="131.5"
                    y="30"
                    width="17"
                    height="8"
                    rx="4"
                    fill="var(--surface-container-high)"
                  />
                </g>
              </>
            )}
            {branding && (
              <g id="Logo Wrapper">
                <rect
                  x="16.5"
                  y="18"
                  width="32"
                  height="32"
                  rx="16"
                  fill="transparent"
                />
                <g id="Colored Icon">
                  <rect
                    id="image 2"
                    x="23.5"
                    y="25"
                    width="18"
                    height="18"
                    fill="url(#pattern0)"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
      </g>
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_185_919" transform="scale(0.0070922)" />
        </pattern>
        <linearGradient
          id="paint0_linear_185_919"
          x1="205.5"
          y1="36"
          x2="192.5"
          y2="47"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="0.31227" />
          <stop offset="1" stopColor="#523527" />
        </linearGradient>
        <clipPath id="clip0_185_919">
          <rect
            x="0.5"
            width="264"
            height="164"
            rx="8"
            fill="var(--surface-container-high)"
          />
        </clipPath>
        <clipPath id="clip1_185_919">
          <rect
            x="180.5"
            y="16"
            width="36"
            height="36"
            rx="4"
            fill="var(--surface-container-high)"
          />
        </clipPath>
        <image
          id="image0_185_919"
          data-name="image.png"
          width="141"
          height="141"
          xlinkHref="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iOCIgZmlsbD0iIzIxMjIyMSIvPgo8cGF0aCBkPSJNMTQuODM1MyAzMC45MzkyQzE3LjY2MDYgMjguMTExNiAxOS40MDc5IDI0LjIwNTEgMTkuNDA3OSAxOS44ODk1QzE5LjQwNzkgMTUuNTc1IDE3LjY2MDYgMTEuNjY3NCAxNC44MzUzIDguODM5NzhMMTEuNTUzMiAxMi4xMjQ3QzEzLjUxMyAxNC4wODYyIDE0LjczNDcgMTYuNzg1NCAxNC43NjY1IDE5Ljc3MTNWMTkuODg5NUMxNC43NjY1IDIyLjkyMTUgMTMuNTM4NyAyNS42NjcyIDExLjU1MzIgMjcuNjU0NEwxNC44MzUzIDMwLjkzOTJaIiBmaWxsPSIjRjVGM0YxIi8+CjxwYXRoIGQ9Ik0xMC42MDI3IDI3LjE1MkMxMi40NTk5IDI1LjI5MzMgMTMuNjA4NyAyMi43MjU1IDEzLjYwODcgMTkuODg5N0MxMy42MDg3IDE3LjA1MzggMTIuNDU5OSAxNC40ODYxIDEwLjYwMjcgMTIuNjI3M0w3LjI5MjgyIDE1Ljk0MUM4LjI2NjA4IDE2LjkxNTEgOC44ODEwMSAxOC4yNDY3IDguOTI0MTMgMTkuNzIxMkM4LjkyOTI4IDE5Ljc0NTggOC45MzIzNSAxOS43NzA1IDguOTMyMzUgMTkuNzk2MkM4LjkzMjM1IDE5LjgxNjcgOC45MzAzIDE5LjgzODMgOC45MjcyMiAxOS44NTc4VjE5Ljg4OTdDOC45MjcyMiAyMS40MzIgOC4zMDE5OSAyMi44Mjc0IDcuMjkyODIgMjMuODM4NVYyMy44MzkzTDEwLjYwMjcgMjcuMTUyWiIgZmlsbD0iI0Y1RjNGMSIvPgo8cGF0aCBkPSJNMjAuNTY2MyAxOS44ODk1QzIwLjU2NjMgMjQuMjA1MSAyMi4zMTM2IDI4LjExMTYgMjUuMTM4OCAzMC45MzkyTDI4LjQyMSAyNy42NTQ0QzI2LjQzNTYgMjUuNjY3MiAyNS4yMDc3IDIyLjkyMTUgMjUuMjA3NyAxOS44ODk1VjE5Ljc3MTNDMjUuMjM5NiAxNi43ODU0IDI2LjQ2MTIgMTQuMDg2MiAyOC40MjEgMTIuMTI0N0wyNS4xMzk5IDguODM5NzhDMjIuMzE0NyAxMS42Njc0IDIwLjU2NzMgMTUuNTc1IDIwLjU2NzMgMTkuODg5NUgyMC41NjYzWiIgZmlsbD0iI0Y1RjNGMSIvPgo8cGF0aCBkPSJNMjkuMzgyOCAyNy4xNTJDMjcuNTI1NyAyNS4yOTMzIDI2LjM3NjggMjIuNzI1NSAyNi4zNzY4IDE5Ljg4OTdDMjYuMzc2OCAxNy4wNTM4IDI3LjUyNTcgMTQuNDg2MSAyOS4zODI4IDEyLjYyNzNMMzIuNjkyNiAxNS45NEMzMS43MjA0IDE2LjkxNTEgMzEuMTA0NSAxOC4yNDU3IDMxLjA2MTQgMTkuNzIxMkMzMS4wNTY0IDE5Ljc0NTggMzEuMDUzMyAxOS43NzA1IDMxLjA1MzMgMTkuNzk2MkMzMS4wNTMzIDE5LjgxNjcgMzEuMDU1MiAxOS44MzgzIDMxLjA1ODMgMTkuODU3OFYxOS44ODk3QzMxLjA1ODMgMjEuNDMyIDMxLjY4MzUgMjIuODI3NCAzMi42OTI2IDIzLjgzODVWMjMuODM5M0wyOS4zODI4IDI3LjE1MloiIGZpbGw9IiNGNUYzRjEiLz4KPC9zdmc+Cgo="
        />
      </defs>
    </svg>
  );
};
